import React, { useState, useEffect } from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

const ModalAddTeam = ({ open, onClose, onSubmit, data = null }) => {
  const [formData, setFormData] = useState({
    teamName: '',
    spName1: '',
    category1: '',
    date1: '',
    spName2: '',
    category2: '',
    date2: '',
    spName3: '',
    category3: '',
    date3: '',
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }
  useEffect(() => {
    if (data)
      setFormData({
        teamName: data.teamName,
        spName1: data.spName1,
        category1: data.category1,
        date1: data.date1,
        spName2: data.spName2,
        category2: data.category2,
        date2: data.date2,
        spName3: data.spName3,
        category3: data.category3,
        date3: data.date3,
      })
  }, [data])

  const validateForm = () => {
    const newErrors = {}
    if (!formData.teamName.trim()) newErrors.teamName = 'Обязательное поле'
    if (!formData.spName1.trim()) newErrors.spName1 = 'Обязательное поле'
    // if (!formData.category1.trim()) newErrors.category1 = 'Обязательное поле'
    // if (!formData.date1.trim()) newErrors.date1 = 'Обязательное поле'

    if (formData.spName2.trim() !== '') {
      // if (!formData.category2.trim()) newErrors.category2 = 'Обязательное поле'
      // if (!formData.date2.trim()) newErrors.date2 = 'Обязательное поле'
    }

    if (formData.spName3.trim() !== '') {
      // if (!formData.category3.trim()) newErrors.category3 = 'Обязательное поле'
      // if (!formData.date3.trim()) newErrors.date3 = 'Обязательное поле'
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validateForm()) return

    setLoading(true)
    try {
      await onSubmit(formData)
      onClose()
    } catch (error) {
      console.error('Ошибка сохранения:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }))
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h6">Добавить новую команду</Typography>
        <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
          В созданных вами командах спортсмены не смогут редактировать свои
          данные, загружать автарки и использовать их снова. Они могут
          самостоятельно подать заявку из своего личного кабинета
          www.protocarp.ru
        </Typography>
        <TextField
          id="outlined-basic"
          label="Название команды"
          variant="outlined"
          fullWidth
          error={!!errors.teamName}
          helperText={errors.teamName}
          value={formData.teamName}
          onChange={handleChange('teamName')}
          sx={{ mt: 2 }}
        />

        <TextField
          id="outlined-basic"
          label="ФИО спортсмена 1"
          variant="outlined"
          fullWidth
          error={!!errors.spName1}
          helperText={errors.spName1}
          value={formData.spName1}
          onChange={handleChange('spName1')}
          sx={{ mt: 2 }}
        />
        <Stack spacing={1} direction="row" sx={{ mt: 2 }}>
          <FormControl fullWidth error={!!errors.category1}>
            <InputLabel>Категория</InputLabel>
            <Select
              value={formData.category1}
              label="Категория"
              onChange={handleChange('category1')}
            >
              <MenuItem value={'б/р'}>б/р</MenuItem>
              <MenuItem value={'3р'}>3р</MenuItem>
              <MenuItem value={'2р'}>2р</MenuItem>
              <MenuItem value={'1р'}>1р</MenuItem>
              <MenuItem value={'КМС'}>КМС</MenuItem>
              <MenuItem value={'МС'}>МС</MenuItem>
              <MenuItem value={'МСМК'}>МСМК</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Дата рождения"
            type="date"
            fullWidth
            value={formData.date1 || ''}
            onChange={(e) => handleChange('date1')(e)}
            // onChange={handleChange('date1')}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors.date1}
          />
        </Stack>
        <TextField
          id="outlined-basic"
          label="ФИО спортсмена 2"
          variant="outlined"
          fullWidth
          error={!!errors.spName2}
          helperText={errors.spName2}
          value={formData.spName2}
          onChange={handleChange('spName2')}
          sx={{ mt: 1 }}
        />
        <Stack spacing={1} direction="row" sx={{ mt: 2 }}>
          <FormControl fullWidth error={!!errors.category2}>
            <InputLabel>Категория</InputLabel>
            <Select
              value={formData.category2}
              label="Категория"
              onChange={handleChange('category2')}
            >
              <MenuItem value={'б/р'}>б/р</MenuItem>
              <MenuItem value={'3р'}>3р</MenuItem>
              <MenuItem value={'2р'}>2р</MenuItem>
              <MenuItem value={'1р'}>1р</MenuItem>
              <MenuItem value={'КМС'}>КМС</MenuItem>
              <MenuItem value={'МС'}>МС</MenuItem>
              <MenuItem value={'МСМК'}>МСМК</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Дата рождения"
            type="date"
            fullWidth
            value={formData.date2 || ''}
            onChange={(e) => handleChange('date2')(e)}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors.date2}
          />
        </Stack>
        <TextField
          id="outlined-basic"
          label="ФИО спортсмена 3"
          variant="outlined"
          fullWidth
          error={!!errors.spName3}
          helperText={errors.spName3}
          value={formData.spName3}
          onChange={handleChange('spName3')}
          sx={{ mt: 1 }}
        />
        <Stack spacing={1} direction="row" sx={{ mt: 2 }}>
          <FormControl fullWidth error={!!errors.category3}>
            <InputLabel>Категория</InputLabel>
            <Select
              value={formData.category3}
              label="Категория"
              onChange={handleChange('category3')}
            >
              <MenuItem value={'б/р'}>б/р</MenuItem>
              <MenuItem value={'3р'}>3р</MenuItem>
              <MenuItem value={'2р'}>2р</MenuItem>
              <MenuItem value={'1р'}>1р</MenuItem>
              <MenuItem value={'КМС'}>КМС</MenuItem>
              <MenuItem value={'МС'}>МС</MenuItem>
              <MenuItem value={'МСМК'}>МСМК</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Дата рождения"
            type="date"
            fullWidth
            value={formData.date3 || ''}
            onChange={(e) => handleChange('date3')(e)}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors.date3}
          />
        </Stack>
        <Typography variant="body2" gutterBottom>
          Созданные команды сразу попадают в основной список с подтвержденной
          регистрацией.
        </Typography>
        <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Отмена
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleSubmit}
            disabled={loading}
            startIcon={loading && <CircularProgress size={20} />}
          >
            {loading ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalAddTeam
